import { Search as BaseComponent } from "lemans-brandsites-common/components/Search/Search.component";
import * as React from 'react';
import './Search.styles.less';
import { ISearchProps } from "./Search.types";

export const Search = (props:ISearchProps) => <BaseComponent {...props} />;
